<template>
  <el-dialog
    title="绑定/更换设备"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close ="handleClose">
      <el-form
        ref="formData"
        class="global-form2"
        :model="formInfo"
        label-position="right"
        label-width="110px">
        <el-form-item label="工人姓名">{{formInfo.workerName}}</el-form-item>
        <el-form-item label="所属项目">{{formInfo.projectName}}</el-form-item>
        <el-form-item label="设备编号" prop="supplierId">
          <el-select v-model="formInfo.deviceNumber" clearable filterable  placeholder="请选择设备编号">
            <el-option
              v-for="item in deviceList"
              :key="item.deviceNumber"
              :label="item.deviceNumber + '(' + item.deviceName + ')'"
              :value="item.deviceNumber"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveForm" :disabled='submitShow'>保存</el-button>
          <el-button @click="handleClose">取消</el-button>
        </el-form-item>
      </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: 'Bind',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: {
        deviceNumber: ''
      }
    }
  },
  data () {
    return {
      deviceList: [],
      submitShow: false,
      formInfo: {}
    }
  },
  watch: {
    dialogVisible (val) {
      val && this.getDeviceList()
    },
    info (val) {
      this.getWorkerInfo(val.workerId)
    }
  },

  created () {
  },
  methods: {
    getWorkerInfo (workerId) {
      this.$axios.get(this.$apis.worker.selectYhWorkerByWorkerIdJg, {
        workerId: workerId
      }).then(res => {
        this.formInfo = res || {}
      })
    },
    getDeviceList () {
      this.$axios.get(this.$apis.laborManage.selectYhDeviceByList, {
        projectId: this.info.projectId
      }).then(res => {
        this.deviceList = res || []
      })
    },
    saveForm () {
      this.submitShow = true
      this.$axios.post(this.$apis.worker.updateYhWorkerJg, this.formInfo).then(() => {
        this.$message.success('保存成功')
        this.handleClose()
        this.$emit('success')
      }).finally(() => {
        this.submitShow = false
      })
    },
    handleClose () {
      this.$emit('update:dialogVisible', false)
    }
  }

}
</script>

<style scoped lang="scss">
.global-form2 .el-textarea {
  width: 380px;
}
</style>
